<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                   
                    <v-card elevation="1" class="mt-3 pa-5" >
                       <h3>Charger Info</h3>
                       <v-simple-table>
                           <tbody>
                           <tr>
                               <th class="listHeader tableLinerT" style="width:20%">Registration Date</th>
                               <td class="tableLinerT text-left pl-5">{{INS_DTM}}</td>
                               <th class="listHeader tableLinerT" style="width:20%">Chager Station Name</th>
                               <td class="tableLinerT text-left pl-5">{{BSS_NM}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader">Model</th>
                               <td class="text-left pl-5" >{{CHRG_MODEL}} </td>
                               <th class="listHeader">Charger ID</th>
                               <td class="text-left pl-5" >{{CHARGER_ID}} </td>
                           </tr>
                           
                           <tr>
                               <th class="listHeader">Battery ID 1</th>
                               <td class="text-left pl-5">{{CELL_ID1}}</td>
                               <th class="listHeader">SOC 1</th>
                               <td class="text-left pl-5">{{SOC1}} %</td>
                           </tr>
                           <tr>
                               <th class="listHeader">Current 1</th>
                               <td class="text-left pl-5">{{CURRENT1}} A</td>
                               <th class="listHeader">TEMP 1</th>
                               <td class="text-left pl-5">{{TEMP1}} ℃</td>
                           </tr>
                          
                           <tr>
                               <th class="listHeader">Battery ID 2</th>
                               <td class="text-left pl-5">{{CELL_ID2}}</td>
                               <th class="listHeader">SOC 2</th>
                               <td class="text-left pl-5">{{SOC2}} %</td>
                           </tr>
                           <tr>
                               <th class="listHeader">Current 2</th>
                               <td class="text-left pl-5">{{CURRENT2}} A</td>
                               <th class="listHeader">TEMP 2</th>
                               <td class="text-left pl-5">{{TEMP2}} ℃</td>
                           </tr>

                           <tr>
                               <th class="listHeader">Charger Error</th>
                               <td class="text-left pl-5">{{CHARGER_ERROR}}</td>
                               <th class="listHeader">Battery Error</th>
                               <td class="text-left pl-5">{{BAT_ERROR}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader">Lock Device Error</th>
                               <td class="text-left pl-5">{{DEVICE_ERROR}}</td>
                               <th class="listHeader">Battery Error</th>
                               <td class="text-left pl-5">{{BAT_ERROR}}</td>
                           </tr>
                           </tbody>
                        </v-simple-table>

                        <div class="d-flex justify-space-between dense pa-0 mt-10">
                            <div class="pa2 " >
                                <v-btn color="grey lighten-2 px-5" small @click="goBack" >Back</v-btn>
                            </div>
                            
                            <div class="pa2 ">
                               <!-- 
                                   <v-btn color="red lighten-2" small dark class="ml-2 px-5">Delete</v-btn>
                                <v-btn color="primary" small dark class="ml-2 px-6" @click="editInfo()">Edit</v-btn>
                                -->
                            </div>
                        </div>

                    </v-card>

                </div>
            </div>
        </div>
        <Footer/>


      
    </div>
</template>



<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    .tableLinerR {border-right:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerB {border-bottom:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerT {border-top:1px solid rgb(0, 0, 0, 0.12)}
    tbody tr:hover { background-color: transparent !important; }
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
//import SummeryCnt from '@/components/summeryCnt.vue'
import Footer from '@/components/footerComponent.vue'
//import ErrorDialog from '@/components/errorDialog.vue'
import Navs from '@/components/nav.vue'

export default {
    name: 'BssLogDetail',
    components: {
        Gnb, Footer, PageCrumbs,  Navs, 
        //ErrorDialog
    },

    data () {
        return {
             // login Info
            gnbCode:"3", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:2, navCode2:21, 
            // Page Title & Breadcrumbs
            pTitles: "Detail",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'Charger', disabled: true,}, { text: 'Charger Log', disabled: true,}, { text: 'Detail', disabled: false,}],
            NavList: [ 
                        { title: 'Charger Management', nums: '1',
                            items: [ { title: 'Charger List', nums:11, href:'/Bss' , icons:'mdi-format-list-bulleted' },{ title: 'New Registration', nums:12, href:'/BssWrite', icons:'mdi-lead-pencil' },],
                        },
                        { title: 'Charger Log', nums: '2',
                            items: [ { title: 'Charger Log',nums:21, href:'/BssLog', icons:'mdi-format-list-bulleted' },],
                        },
                    ],    


            schBssLogSeq:'', schBssLogCID:'',
            INS_DTM: "", BSS_NM: "",
            CHRG_MODEL: "", CHARGER_ID: "", 
            CELL_ID1: "", SOC1: "", CURRENT1: "", TEMP1: "", VOLTAGE1: "",
            CELL_ID2: "", SOC2: "", CURRENT2: "", TEMP2: "", VOLTAGE2: "",
            CHARGER_ERROR: "", BAT_ERROR: "",
            DEVICE_ERROR: "", STATUS: "",
            

            chkListFlag : false,  asyncErrors: false, asyncSuccess: false,
            today: new Date().toISOString().substr(0, 10),
            
            emptyFlag:true,emptyHistoryFlag:true,
            max:100, 
            
            
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch((error) => {
                console.log(error);
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
/*
        localStorage.removeItem("schBssLogSeq");
        localStorage.removeItem("schBssLogCID");
*/
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        console.log('param 확인' + this.$route.params.Seq +" / "+ this.$route.params.ChrgID);
        this.schBssLogSeq = this.$route.params.schBssLogSeq; 
        if(this.schBssLogSeq == '' || this.schBssLogSeq == undefined) {
            this.schBssLogSeq = localStorage.getItem("schBssLogSeq");
        } 
        if(this.schBssLogSeq != '') {
            this.getInfo();
           // this.getHistory();
        } else {
            alert("Not Data");
            this.$router.replace('BssLog');
        }
        window.scrollTo(0, 0);
    },

    methods : {
    
        // API Async 
        getInfo() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode":this.loginInfo3
                    , "act": "R"
                    , "mqSeq": this.schBssLogSeq
         
                })
            };

            console.log(JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode":this.loginInfo3
                    , "act": "R"
                    , "mqSeq": this.schBssLogSeq

                }))
            var apiURL = "https://api.e3bss.com/_APP/POC/bssLog.php"; 
                        
            fetch(apiURL, requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                console.log(json);
                if(json.result == "success") {

                    this.INS_DTM = json.INS_DTM; this.BSS_NM = json.BSS_NM; this.CHRG_MODEL = json.CHRG_MODEL; 
                    this.CHARGER_ID = json.CHARGER_ID;
                    this.CELL_ID1 = json.CELL_ID1;
                    this.SOC1 = Number(json.SOC1); this.CURRENT1 = json.CURRENT1; 
                    this.TEMP1 = json.TEMP1; this.VOLTAGE1 = json.VOLTAGE1; 

                    this.CELL_ID2 = json.CELL_ID2;
                    this.SOC2 = Number(json.SOC2); this.CURRENT2 = json.CURRENT2; 
                    this.TEMP2 = json.TEMP2; this.VOLTAGE2 = json.VOLTAGE2; 

                    this.CHARGER_ERROR = json.CHARGER_ERROR; 
                    this.BAT_ERROR = json.BAT_ERROR;
                    this.DEVICE_ERROR = json.DEVICE_ERROR; 
                    this.STATUS = json.STATUS; 
                    
                    this.emptyFlag = false;

                } else {
                   
                    this.emptyFlag = true;
                    
                }
            }).catch((error) => {
                console.log(error);
            });
        },
        
        // back button
        goBack() {
            //console.log('back');
            //return this.$router.go(-1);
            this.$router.push({ name: 'BssLog'});
        },

        

    }

}
</script>
